import script from "./VModalConfirm.vue?vue&type=script&setup=true&lang=ts"
export * from "./VModalConfirm.vue?vue&type=script&setup=true&lang=ts"

import "./VModalConfirm.vue?vue&type=style&index=0&id=10b8033c&lang=scss"

const __exports__ = script;

export default __exports__